import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EXPERT_REPORT_COMPARE_WITH, useExpertReportPeriod, useExportFileDownload } from '@features/expertReports'
import type { ReportExportFormat } from '@features/expertReports'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { EXPERT_PROFIT_AND_LOSS_COMPARE_COUNT, fetchExpertProfitAndLossExport } from '../query-api'
import { useExpertProfitAndLossSearchParam } from './useExpertProfitAndLossSearchParam'

interface UseDownloadExpertProfitAndLossExportResult {
  downloadExport: (format: ReportExportFormat) => Promise<void>
  isExporting: boolean
}

export const useDownloadExpertProfitAndLossExport = (): UseDownloadExpertProfitAndLossExportResult => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { encodedPeriod } = useExpertReportPeriod()
  const { search } = useExpertProfitAndLossSearchParam()

  const fetchExport = useCallback(
    (format: ReportExportFormat) =>
      fetchExpertProfitAndLossExport({
        compareCount: EXPERT_PROFIT_AND_LOSS_COMPARE_COUNT,
        compareWith: EXPERT_REPORT_COMPARE_WITH,
        format,
        organizationId: organization?.id ?? '',
        period: encodedPeriod,
        search: search || undefined,
      }),
    [encodedPeriod, organization?.id, search],
  )

  return useExportFileDownload({
    errorMessage: t('expert_profit_and_loss.export.error'),
    fetchExport,
    isReady: !!organization?.id && !!encodedPeriod,
    notificationKey: NotificationKeys.ExpertProfitAndLossExport,
  })
}
